module.exports = __webpack_public_path__ + "UX25.png?7605b38d3b05de6505f2f0937bc5fe88";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX25.png
// module id = 74
// module chunks = 0